import React from "react";

export const Step = ({ index, title, desc }) => (
    <div className="step">
        <div className="step-badge" aria-hidden="true">{index}</div>
        <h4 className="h4">{title}</h4>
        <p className="muted">{desc}</p>
    </div>
);
